import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeModal: {
		id: 'servicedesk-customers-organization-common.common.collapsible-section-message.close-modal',
		defaultMessage: 'Close',
		description: 'Close icon for collapsible message section.',
	},
});
